import React from 'react';
import { useState } from 'react';
import { RiEyeLine, RiEyeOffLine } from "react-icons/ri";
import { useForm } from 'react-hook-form';
import { toast } from 'react-hot-toast';
import { Link, useNavigate } from 'react-router-dom';

const ResetPassSet = () => {
    const number = localStorage.getItem('phone')
    const [toggle1, setToggle1] = useState(false);
    const { register, handleSubmit, formState: { errors }, reset } = useForm();
    const navigate = useNavigate()

    const changePassword = async (data) => {
        const user = {
            phone: number,
            otp: data.otp,
            new_password: data.password
        }
        console.log(user)

        fetch(`${process.env.REACT_APP_SECRET_API}/reset-password`, {
            method: "POST",
            headers: {
                "X-Requested-With": "XMLHttpRequest",
                "content-type": "application/json",
            },
            body: JSON.stringify(user),
        })
            .then((res) => res.json())
            .then((data) => {
                // console.log(data)
                if (data.success === true) {
                    toast.success("Successfully Change Password");
                    localStorage.removeItem('phone')
                    navigate("/login")
                } else {
                    toast.error(data.message);
                    console.log(data)
                }
                reset()
            })
    }

    return (
        <div>
            <div className="contain py-16">
                <div className="max-w-md bg-white mx-auto shadow px-6 py-7 rounded overflow-hidden">
                    <h2 className="text-2xl uppercase font-medium text-center text-black mb-1">Change Password</h2>
                    <p className="text-gray-600 mb-6 text-center text-sm">
                        Register for new customer
                    </p>
                    <div className="divider"></div>
                    <form onSubmit={handleSubmit(changePassword)}>
                        <div className="space-y-2">
                            
                            <div>
                                <label htmlFor="number" className="text-[#0364BE] mb-2 block">Otp</label>
                                <input type="text" name="number"
                                    className="block bg-white w-full border border-gray-300 px-4 py-3 text-gray-600 text-sm rounded focus:ring-0 focus:border-primary placeholder-gray-400"
                                    placeholder="1234"
                                    {...register("otp", {
                                        required: {
                                            value: true,
                                            message: "Number is Required"
                                        },
                                        pattern: {
                                            value: /^[0-9]*$/,
                                            message: "Only give number."
                                        },
                                      
                                        maxLength: {
                                            value: 4,
                                            message: "No more than 4 digits can be given"
                                        }
                                    })}
                                />
                                <span className='text-xs text-red-500 text-left'>{errors.otp?.message}</span>
                            </div>

                            <div>
                                <label htmlFor="number" className="text-[#0364BE] mb-2 block">Password</label>

                                {/* icon show password */}

                                {(toggle1 === false) ? <RiEyeOffLine className='text-black cursor-pointer absolute mt-3 ml-[350px]' onClick={() => setToggle1(!toggle1)}></RiEyeOffLine> : <RiEyeLine className='text-red-500 cursor-pointer absolute mt-3 ml-[350px]' onClick={() => setToggle1(!toggle1)}></RiEyeLine>}


                                <input type={toggle1 ? "text" : "password"} name="number"
                                    className="block bg-white w-full border border-gray-300 px-4 py-3 text-gray-600 text-sm rounded focus:ring-0 focus:border-primary placeholder-gray-400"
                                    placeholder="••••••••"
                                    {...register("password", {
                                        required: {
                                            value: true,
                                            message: "password is Required"
                                        },
                                        // pattern: {
                                        //     value: /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{6,}$/,
                                        //     message: "Minimum six characters, at least one letter and one number"
                                        // },
                                        minLength: {
                                            value: 6,
                                            message: "Must be exceed 6 characters"
                                        }
                                    })}
                                />
                                <span className='text-xs text-red-500 text-left'>{errors.password?.message}</span>
                            </div>
                        </div>
                        <div className="mt-4">
                            <button type="submit"
                                className="block w-full py-2 text-center text-white  border border-primary rounded bg-gradient-to-r from-primary to-[#52a3eb] hover:from-[#52a3eb] hover:to-primary transition uppercase font-roboto font-medium">
                                    Change Password
                            </button>
                        </div>
                    </form>
                    <p className="mt-4 text-center text-gray-600">Already have account? <Link to="/login"
                        className="text-primary">Login now</Link></p>
                </div>
            </div>
        </div>
    );
};

export default ResetPassSet;